<template>
	<div class="vendor-message-wrapper">
		<div class="vendor-message">
			<FallBack
				v-if="error"
				:message="error"
				:border="false"
				:transparentBackground="true"
				iconStyle="fal"
				icon="exclamation-triangle"
			/>
			<p v-if="leadIdList < 1" class="vendor-message-text">
				Are you sure you would like to send
				<span class="bolded-message-text"
					>{{ leadData.firstName }} {{ leadData.lastName }}</span
				>
				the Vendor Link?
			</p>
			<p v-else class="vendor-message-text">
				Are you sure you would like to send the selected contacts the Vendor
				Link?
			</p>
		</div>
		<OverviewModalFooter
			:isSaveModal="true"
			:primaryButtonName="
				!vendorLinkRegistered && !error ? 'Send to Vendor' : 'Send'
			"
			:waiting="waiting"
			:success="success"
			@close="$emit('handleClose')"
			@handleClick="
				vendorLinkRegistered && !error ? sendToVendor() : $emit('handleClose')
			"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import OverviewModalFooter from './OverviewModalFooter.vue';
import FallBack from '../../../components/global/FallBack.vue';
import leadsService from '@/services/contacts/leads-service.js';

export default {
	name: 'SendToVendor',
	components: {
		OverviewModalFooter,
		FallBack,
	},
	props: {
		leadId: Number,
		leadData: Object,
		vendorLinkRegistered: Boolean,
		leadIdList: Array,
	},
	data() {
		return {
			waiting: false,
			success: false,
			error: null,
		};
	},
	computed: {
		...mapGetters(['currentUserProfile']),
	},
	methods: {
		async sendToVendor() {
			const leadIds =
				this.leadIdList.length < 1 ? [this.leadId] : this.leadIdList;
			const { contactId, entityId } = this.currentUserProfile;
			const payload = {
				leadIds,
				contactId,
				entityId,
			};
			this.waiting = true;
			try {
				await leadsService.sendLeadToVendor(payload);

				this.success = true;

				setTimeout(() => {
					this.$emit('vendorLinkSent');
					this.success = false;
				}, 1500);
			} catch (error) {
				this.error = error;
			}
			this.waiting = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.vendor-message-wrapper {
	.vendor-message {
		@include rem('padding', 20px);
	}

	p.vendor-message-text {
		margin: 0;
		padding: 0;
		@include rem('line-height', 25px);
	}

	.cc-link {
		@include typo--roboto__medium;
		color: $brand-blue;
		text-decoration: none;
	}
}

.bolded-message-text {
	@include typo--roboto__bold;
}
</style>
